import { useAuthContext } from '../hooks/useAuthContext'
import { useWorkoutsContext } from '../hooks/useWorkoutsContext'
// date fns
import formatDistanceToNow from 'date-fns/formatDistanceToNow'

const WorkoutDetails = ({ workout }) => {
  const { dispatch } = useWorkoutsContext()
  const { user } = useAuthContext()

  const handleClick = async () => {
    if (!user) {
      return
    }

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/workouts/` + workout._id,
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    )
    // json of the workout that was just deleted
    const json = await response.json()

    if (response.ok) {
      dispatch({ type: 'DELETE_WORKOUT', payload: json })
    }
  }
  return (
    <div className="workout-details">
      <h4>{workout.title}</h4>
      <p>
        {' '}
        <strong> Reps :</strong> {workout.reps}
      </p>
      <p>
        <strong> Load(kg) :</strong> {workout.load}
      </p>
      <p>
        {/* {workout.createdAt} */}
        {formatDistanceToNow(new Date(workout.createdAt), { addSuffix: true })}
      </p>
      <span className="material-symbols-outlined" onClick={handleClick}>
        delete
      </span>
    </div>
  )
}

export default WorkoutDetails
